import css from "./index.module.css";
import Header from '../../components/Header';

const Student = () => {
    return (
        <div className={css.page}>
            <Header isTeacher={false}/>
            <span>Hello Student</span>
        </div>
    );
};
export default Student;